<template>
  <div class="box">
    {{ $t('message.paste_warning') }}
  </div>
</template>

<script>
export default {
  name: 'addressWarning'
}

</script>

<style scoped>
  .box {
    margin-top: 30px;
    border: 1px solid orangered;
    border-left: 6px solid red;
    border-radius: 4px;
    padding: 12px;
    font-weight: 500;
  }
</style>
